// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QGIdy","badges":"styles_badges__102Fd"};